import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import Team from "../../model/team.model";
import TeamStatistic from "../../model/teamStatistic.model";

@Injectable()
export default class TeamService {
    public constructor(private http: HttpClient) {
    }
    public list(): Observable<Team[]> {
        return this.http.get<Team[]>(environment.apiUrl + '/teams');
    }

    public statistics(team: Team): Observable<TeamStatistic> {
        return this.http.get<TeamStatistic>(environment.apiUrl + '/teams/' + team.id + '/statistic');
    }
}
